import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cxtpayment',
  templateUrl: './cxtpayment.component.html',
  styleUrls: ['./cxtpayment.component.scss']
})
export class CxtpaymentComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
